import Portfolio from '../portfolio';

/**
 * Create the action
 */

const { thunk, request, success, error } = Portfolio.index((fetch) => {
    return fetch.get('/portfolios');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
